var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiChatIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.379 56.578c11.329-.753 20.353-9.905 21.095-21.394a53.53 53.53 0 000-6.826c-.742-11.49-9.766-20.642-21.095-21.395a89.87 89.87 0 00-11.758 0C15.292 7.716 6.268 16.87 5.525 28.358a53.493 53.493 0 000 6.826c.27 4.184 2.122 8.059 4.3 11.33 1.266 2.291.43 5.15-.887 7.647-.95 1.8-1.425 2.7-1.044 3.35.382.651 1.234.672 2.938.713 3.37.082 5.642-.873 7.445-2.203 1.023-.755 1.535-1.132 1.888-1.175.352-.043 1.046.242 2.433.814 1.247.513 2.695.83 4.023.918 3.857.257 7.893.258 11.758 0z",
    fill: "url(#ai-chat-icon_svg__paint0_linear_419_5950)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.313 40.625L25.3 25.66a1.879 1.879 0 013.565 0l4.988 14.965m8.125-16.25v16.25m-18.958-5.417h8.125",
    stroke: "#AEF600",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-chat-icon_svg__paint0_linear_419_5950",
    x1: 32.5,
    y1: 6.771,
    x2: 32.5,
    y2: 58.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })))));
}
export default SvgAiChatIcon;